module.exports = __webpack_public_path__ + "static/media/4027561895f79b9a6926d84bba9c608.2edece52.jpg";